

import {ApiV0ResourceManager} from '../api.v0.resource-manager';
import {RestApiService} from '../../../rest-api.service';
import {BaseCollectionModel} from '@yasc/yasc-material-components';
import {
    CalendarEntryCreateBatchReq,
    CalendarEntryCreateTypedReq,
    CalendarEntryQueryReq,
    CalendarEntryRes,
    CalendarEntryUReq,
    CalendarInvitationRespondReq
} from '../../../../contracts/v0/resource-manager/calendar.contracts';
import {
    CalendarStatsQueryReq,
    CalendarYearStatContractRes
} from '../../../../contracts/v0/resource-manager/calendar-stat.contract';
import {
    CalendarApprovalBatchReq,
    CalendarApprovalSearchReq
} from '../../../../contracts/v0/resource-manager/calendar-approval.contract';
import {
    CompanyProjectBudgetUsageRes,
    CompanyProjectStatsRes,
    CompanyProjectUserYearHoursRes
} from '../../../../contracts/v0/resource-manager/project-stats.contract';
import {CompanyProjectStatsSearchReq} from '../../../../controllers/resource-manager/company-project-stats-search-Req';

export class ApiV0RmCompany {
    segment: string

    constructor(v0: ApiV0ResourceManager, private rest: RestApiService) {
        this.segment = v0.segment + "/company";
    }

    getCompanyProjectStats(req: CompanyProjectStatsSearchReq) {
        return this.rest.post<CompanyProjectStatsSearchReq, CompanyProjectStatsRes>(
            `${this.segment}/project-stats`,
            CompanyProjectStatsRes,
            req
        );
    }

    getCompanyProjectHoursByUserYear(req: CompanyProjectStatsSearchReq) {
        return this.rest.post<CompanyProjectStatsSearchReq, CompanyProjectUserYearHoursRes>(
            `${this.segment}/project-hours-by-user-year`,
            CompanyProjectUserYearHoursRes,
            req
        );
    }

    getCompanyProjectBudgetUsage(req: CompanyProjectStatsSearchReq) {
        return this.rest.post<CompanyProjectStatsSearchReq, CompanyProjectBudgetUsageRes>(
            `${this.segment}/project-budget-usage`,
            CompanyProjectBudgetUsageRes,
            req
        );
    }

    get projectBudgetExportUrl(): string {
        return `${this.segment}/project-budget-export`;
    }

}
